import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useStateIfMounted } from "use-state-if-mounted";
import { useAlert } from "react-alert";
import { decode as base64_decode, encode as base64_encode } from "base-64";
const appparameters = require("./../../../core/common.jsx");

export const AddAccount = (props) => {
  const alert = useAlert();
  const [state, setState] = useStateIfMounted({
    first_name: "",
    last_name: "",
    username: "",
    email: "",
    mailsyn: false,
    pass: "",
    cpass: "",
    disabled: false,
    key: "",
  });

  const history = useHistory();
  const handleClick = () => history.push("/");

  function handleSubmit(event) {
    event.preventDefault();
    setState({ ...state, disabled: true });
    let can_proceed = true;
    let emailregex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let passstrongRegex =
      /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,64}$/; // "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})"
    //let usernameregex = new RegExp("^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$");
    if (state.username.length < 6 && state.username.length > 64) {
      can_proceed = false;
      setState({ ...state, username: "", disabled: false });
      alert.show("Username must be between six and 64 characters.", {
        type: "error",
        position: "middle",
      });
      return;
    }
    if (!emailregex.test(state.email)) {
      can_proceed = false;
      setState({ ...state, email: "", disabled: false });
      alert.show("Email address not valid", {
        type: "error",
        position: "middle",
      });
      return;
    }
    if (!passstrongRegex.test(state.pass)) {
      can_proceed = false;
      setState({ ...state, pass: "", cpass: "", disabled: false });
      alert.show(
        "Password must be minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character",
        { type: "error", position: "middle" }
      );
      return;
    }
    if (state.pass != state.cpass) {
      can_proceed = false;
      setState({ ...state, pass: "", cpass: "", disabled: false });
      alert.show("Confirm password doesn't match New password", {
        type: "error",
      });
      return;
    }
    if (can_proceed) {
      let temp_state = { ...state };
      temp_state.pass = base64_encode(temp_state.pass);
      temp_state.date = Math.floor(Date.now() / 1000);
      temp_state.verified = false;
      delete temp_state.cpass;
      delete temp_state.disabled;
      //state.cpass = base64_encode(state.cpass);
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(temp_state),
      };

      fetch(
        appparameters.backend_app_url + "/frontend/addaccount",
        requestOptions
      )
        .then((response) => response.json())
        .then((responseData) => {
          if (responseData) {
            history.push("/");
            alert.show(
              "Successfully registered, A verification link has been sent to your email account",
              { type: "success", position: "middle" }
            );
          } else {
            setState({ ...state, disabled: false });
            alert.show("Failed to register", {
              type: "error",
              position: "middle",
            });
          }
        })
        .catch((error) => console.warn(error));
    }
  }
  useEffect(() => {
    setState({ ...state, disabled: false });
  }, []);

  if (state.disabled) {
    return (
      <div className="container">
        <center>
          <img
            src={require("./../../../images/simpleloading.gif")}
            className="simpleloadingview"
          />
          <p>
            <strong>Loading registration ...</strong>
            <br />
          </p>
        </center>
      </div>
    );
  } else {
    return (
      <React.Fragment>
        <form className="container" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="col-md-6 mb-3">
              <label>First Name *</label>
              <input
                type="text"
                className="form-control"
                placeholder="First name"
                value={state.first_name}
                onChange={(e) =>
                  setState({ ...state, first_name: e.target.value })
                }
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <label>Last Name *</label>
              <input
                type="text"
                className="form-control"
                placeholder="Last name"
                value={state.last_name}
                onChange={(e) =>
                  setState({ ...state, last_name: e.target.value })
                }
                required
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-6 mb-3">
              <label htmlFor="validationDefaultUsername">Username *</label>
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="inputGroupPrepend2">
                    @
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  id="validationDefaultUsername"
                  placeholder="Username"
                  aria-describedby="inputGroupPrepend2"
                  value={state.username}
                  onChange={(e) =>
                    setState({ ...state, username: e.target.value })
                  }
                  required
                />
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="validationDefault02">Email *</label>
              <input
                type="email"
                className="form-control"
                placeholder="Email address"
                value={state.email}
                onChange={(e) => setState({ ...state, email: e.target.value })}
                required
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-6 mb-3">
              <label>Password *</label>
              <input
                type="password"
                className="form-control"
                placeholder="Password"
                value={state.pass}
                onChange={(e) => setState({ ...state, pass: e.target.value })}
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <label>Confirm Password *</label>
              <input
                type="password"
                className="form-control"
                placeholder="Confirm password"
                value={state.cpass}
                onChange={(e) => setState({ ...state, cpass: e.target.value })}
                required
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={state.mailsyn}
                onChange={(e) =>
                  setState({ ...state, mailsyn: e.target.checked })
                }
              />
              <label className="form-check-label">
                Sync account with email
              </label>
            </div>
          </div>
          <div className="alert alert-info" role="alert">
            Registered account will be active when you verify your email
            ownership.<br></br>
            *Required fields must be filled in.
          </div>
          <button
            className="btn btn-primary"
            type="submit"
            disabled={state.disabled}
          >
            Submit
          </button>
          &nbsp;
          <button
            className="btn btn-secondary"
            type="button"
            onClick={handleClick}
          >
            Cancel
          </button>
        </form>
      </React.Fragment>
    );
  }
};
